import styles from "./tools.module.css";
const Tools = () => {
  return (
    <div className={styles.main}>
      <div className={styles.text}>
        The tools I usually use / i'm learning to use :
      </div>
      <div className={styles.list}>
        <div className={`${styles.section} w-1/2 md:w-1/2 lg:w-1/3 mb-12`}>
          <div className={styles.title}>For Software Development</div>
          <ul className={styles.innerList}>
            <li>
              Cmake
              <a href="https://cmake.org/" target="_blank" rel="noreferrer">
                <i className="far fa-link"></i>
              </a>
            </li>
            {/* <li>
              Google Test
              <a
                href="https://github.com/google/googletest"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li> */}
            {/* <li>
              Catch 2
              <a
                href="https://github.com/catchorg/Catch2"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li> */}
            {/* <li>
              Postgre SQL
              <a
                href="https://www.postgresql.org/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li> */}
            <li>
              MySQL
              <a href="https://www.mysql.com/" target="_blank" rel="noreferrer">
                <i className="far fa-link"></i>
              </a>
            </li>
            <li>
              MongoDB
              <a
                href="https://docs.mongodb.com/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li>
          </ul>
        </div>
        <div className={`${styles.section} w-1/2 md:w-1/2 lg:w-1/3 mb-12`}>
          <div className={styles.title}>
            For Machine Learning & Deep Learning
          </div>
          <ul className={styles.innerList}>
            <li>
              Tensorflow
              <a
                href="https://github.com/tensorflow/tensorflow"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li>
            {/* <li>
              Pytorch
              <a
                href="https://github.com/pytorch/pytorch"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li> */}
            <li>
              OpenCV
              <a
                href="https://github.com/opencv/opencv"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li>
            {/* <li>
              Caffe
              <a
                href="https://github.com/BVLC/caffe"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li> */}
            {/* <li>
              Keras
              <a href="https://keras.io/" target="_blank" rel="noreferrer">
                <i className="far fa-link"></i>
              </a>
            </li> */}
            <li>
              Scikit-Learn
              <a
                href="https://github.com/scikit-learn/scikit-learn"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li>
          </ul>
        </div>
        <div className={`${styles.section} w-1/2 md:w-1/2 lg:w-1/3 mb-12`}>
          <div className={styles.title}>In General</div>
          <ul className={styles.innerList}>
            <li>
              Visual Studio{" "}
              <a
                href="https://visualstudio.microsoft.com/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li>
            <li>
              Visual Studio Code
              <a
                href="https://code.visualstudio.com/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li>
            <li>
              PyCharm
              <a
                href="https://www.jetbrains.com/pycharm/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li>
            <li>
              CLion
              <a
                href="https://www.jetbrains.com/clion/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="far fa-link"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Tools;
